import { Button, Typography, Container, Grid, makeStyles, Paper } from '@material-ui/core';
import { PrimaryButton } from '../../common/PrimaryButton';
import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
// @ts-ignore
import TestSound from './ios_incoming_ring.mp3';
import { useState } from 'react';
import { AudioDevice } from '../AudioTest/AudioDevice/AudioDevice';
import useAudioTest from '../AudioTest/useAudioTest/useAudioTest';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  paper: {
    padding: '23px',
    borderRadius: '8px',
    width: '388px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media screen and (max-width: 400px)': {
      width: '90vw',
      paddingBottom: '10px',
    },
  },
  audioLevelContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '2.5em',
  },
  topLine: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  gridContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media screen and (max-width: 950px)': {
      display: 'flex',
      justifyContent: 'center',
    },
    '@media screen and (max-width: 300px)': {
      height: 'calc(100vh - 100px)',
      overflow: 'auto',
      paddingTop: '50px',
      paddingBottom: '5px',
    },
  },
  mainGridContainer: {
    maxWidth: '95%',
    '@media screen and (max-width: 950px)': {
      paddingTop: '10px',
    },
  },
  primaryButtons: {
    '@media screen and (max-width: 300px)': {
      paddingLeft: '50px',
      height: '80px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
  },
});

export function SpeakersTest() {
  const classes = useStyles();
  const { dispatch } = useAppStateContext();
  const [outputDeviceId, setOutputDeviceId] = useState('');
  const { t } = useTranslation('', { keyPrefix: 'SPEAKERS' });
  const { playAudio, setError, stopAudioTest } = useAudioTest();
  const handlePlayClick = () => {
    playAudio({ deviceId: outputDeviceId, testURI: TestSound });
  };
  function stopAudio() {
    stopAudioTest();
  }

  return (
    <Container>
      <Grid container className={classes.gridContainer}>
        <Grid item md={5}>
          <Typography variant="h1" gutterBottom>
            {t('TEST_YOUR_SPEAKERS')}
          </Typography>

          <Typography variant="body1" gutterBottom>
            {t('PLAY_THE_TEST_SOUND')}
          </Typography>

          <Typography variant="body1" gutterBottom>
            <strong> {t('DOES_AUDIO_SOUND_GOOD')}</strong>
          </Typography>

          <PrimaryButton
            style={{ marginRight: '1.5em', borderRadius: '6px' }}
            color="primary"
            onClick={() => dispatch({ type: 'next-pane' })}
          >
            {t('YES')}
          </PrimaryButton>

          <Button color="primary" disableRipple onClick={() => dispatch({ type: 'next-pane' })}>
            {t('SKIP_FOR_NOW')}
          </Button>
        </Grid>
        ​
        <Grid item md={5} className={classes.mainGridContainer}>
          <Paper className={classes.paper}>
            <div className={classes.topLine}>
              <Typography variant="subtitle2">
                <strong>{t('AUDIO')}</strong>
              </Typography>
              <div className={classes.primaryButtons}>
                <PrimaryButton onClick={handlePlayClick}>{t('PLAY')}</PrimaryButton>
                <PrimaryButton onClick={stopAudio}>{t('STOP')}</PrimaryButton>
              </div>
            </div>
            ​
            <AudioDevice
              disabled={false}
              kind="audiooutput"
              onDeviceChange={setOutputDeviceId}
              setDeviceError={setError}
            />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
